export default function getLastNCharacters(originalString: string, n: number): string {
    if (originalString.length <= n) {
        return originalString;
    } else {
        return originalString.slice(originalString.length - n);
    }
}
